import React from 'react'
import { default as DefaultFooter } from './components/Footer'
import FooterMinimal from './components/FooterMinimal'

// Todo: Set this in the API and dynamically get it
const description =
  'Identify qualified leads & customers and increase your sales LeadBoxer is a Sales Enablement solution, allowing you to identify your most qualified Leads & Customers and get data driven insights into your sales and marketing workflow.'

const Footer = ({ minimal }) => {
  return minimal ? (
    <FooterMinimal />
  ) : (
    <DefaultFooter description={description} />
  )
}

export default Footer
